module.exports = __webpack_public_path__ + "img/safari.6936accf.svg";